import { Box, Button } from "@mui/joy";
import SwipeCards from "../components/LentaAcquaintance/SwipeCards";

import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import { useContext } from "react";
import PageHeader from "../components/ui/PageHeader";
import PageContainer from "../components/ui/PageContainer";
import { LayoutContext } from "../context";


export default function LentaPage() {
    const { setModalSecondQuestionnaire } = useContext(LayoutContext);

    /**
     * Раньше здесь висел useEffect, который открывал большую анкету подбора при
     * заходе в ленту. Массив зависимостей был пустой, а статус профиля приходит
     * асинхронно — на первом рендере он ещё undefined, условие срабатывало всегда,
     * и окно вылезало даже у тех, кто анкету давно заполнил.
     *
     * Теперь анкета подбора открывается только по кнопке «Фильтр».
     */

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
            <PageHeader
                title="Лента"
                suggestion
                actions={
                    <Button
                        startDecorator={<TuneRoundedIcon />}
                        className="lvc-grad-btn"
                        size="sm"
                        onClick={() => setModalSecondQuestionnaire({ open: true })}
                        sx={{ borderRadius: '14px' }}
                    >
                        Фильтр
                    </Button>
                }
            />

            <PageContainer
                className="Lenta"
                sx={{
                    flex: 1,
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                    pb: { xs: 1.5, md: 3 },
                }}
            >
                {/* Одна раскладка для телефона и десктопа: на широком экране колонка
                    просто ограничена по ширине и стоит по центру */}
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        width: '100%',
                        maxWidth: { xs: '100%', md: 440 },
                        mx: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'visible',
                    }}
                >
                    <SwipeCards />
                </Box>
            </PageContainer>
        </Box>
    );
}
